import * as React from 'react';
import { MailToSupport } from '../account/mail-to-support';

type Props = {
  error?: string | null;
};

export default (props: Props) => {
  const { error } = props;

  return error != null ? (
    <>{error}</>
  ) : (
    <>
      Please try again or contact <MailToSupport /> if this problem continues.
    </>
  );
};
